import { Role } from "../../types/role";

const KIAve: Role = {
  primary: ["Deckung", "Tackling", "Antizipation", "Stellungsspiel", "Kraft"],
  secondary: ["Kopfball", "Aggressivitaet", "Konzentration", "Mut", "Teamwork"],
  physis: "abwehr",
};

export const KIA = {
  KIAve,
};
